<app-project-settings-layer-detail-template
    [businessIdentifier]="layerBloc.value()!.businessIdentifier ?? '-'"
    [canDelete]="canDelete()"
    [hasAttributes]="true"
    [subtitle]="labelByLayerType[Layer.TypeEnum.TABLE] | transloco: { COUNT: 1 }"
    [title]="layerBloc.value()?.name ?? ''"
    (deleteLayer)="deleteLayer(layerBloc.value()!.id)"
    (goToPreviousPage)="closeDetail(layerBloc.value()!.id)">
    @if (isLoading()) {
        <app-loading
            class="m-auto"
            size="30" />
    } @else {
        <div class="panel-information flex flex-wrap justify-between gap-x-10 gap-y-6 mt-2 mb-8">
            @for (interstandardDeposit of deposits(); track $index) {
                <div class="flex flex-col min-w-[250px] max-w-sm flex-1">
                    <span class="font-normal text-xl">Source {{ $index + 1 }}</span>
                    <div class="grid grid-cols-2 gap-x-10 gap-y-3 my-2">
                        <div class="flex flex-col">
                            <span class="text-on-surface text-overline">{{ 'depositName' | transloco }}</span>
                            <span class="text-on-background text-subtitle-1">{{ interstandardDeposit.name }}</span>
                        </div>
                        <div class="flex flex-col">
                            <span class="text-on-surface text-overline">{{ 'depositVersion' | transloco }}</span>
                            <span class="text-on-background text-subtitle-1">{{ interstandardDeposit.version }}</span>
                        </div>
                        <div class="flex flex-col">
                            <span class="text-on-surface text-overline">{{ 'standard' | transloco }}</span>
                            <span class="text-on-background text-subtitle-1">{{
                                standardNameByDepositId()[interstandardDeposit.id]
                            }}</span>
                        </div>
                        <div class="flex flex-col">
                            <span class="text-on-surface text-overline">{{ 'depositDate' | transloco }}</span>
                            <span class="text-on-background text-subtitle-1">{{
                                interstandardDeposit.updatedAt | translocoDate
                            }}</span>
                        </div>
                    </div>
                </div>
            } @empty {
                <app-no-data-to-display iconSize="3x" />
            }
        </div>
    }

    <section attributesBookmarked>
        @if (isLoading()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else if (attributesBookmarked()) {
            <app-layer-data-attributes-list [dataAttributes]="attributesBookmarked()!" />
        } @else {
            <app-no-data-to-display
                displayedMessage="noAttribute"
                iconSize="4x" />
        }
    </section>

    <section attributesOther>
        @if (isLoading()) {
            <app-loading
                class="m-auto"
                size="30" />
        } @else if (attributesOther()) {
            <app-layer-data-attributes-list [dataAttributes]="attributesOther()!" />
        } @else {
            <app-no-data-to-display
                displayedMessage="noAttribute"
                iconSize="4x" />
        }
    </section>
</app-project-settings-layer-detail-template>
